import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { getPermissionToTrack, getAccessToken } from '../selectors/getUserInfo';

export const useAccessToken = () => {
    const accessToken = useSelector(getAccessToken);
    return useMemo(() => {
        return accessToken
    }, [accessToken]);
};

export default () => {
    const permissionToTrack = useSelector(getPermissionToTrack);
    return useMemo(() => {
        return permissionToTrack
    }, [permissionToTrack]);
};

